/**
 * Longevity 360 node L5: `lab.result_review_recorded`.
 *
 * Fired by the lab desk after "Verify and save" stored a lab report.
 * Fire-and-forget: the save never waits on it and never fails because of it.
 * `postL360Event` never throws; this sender is a no-op unless VITE_L360_EVENTS is on.
 */
import { isL360EventsEnabled, postL360Event } from '@/shared/services/l360-events';

export const LAB_RESULT_REVIEW_RECORDED = 'lab.result_review_recorded';

export interface ResultReviewRecordedInput {
  patientId: string;
  labRequestId: string;
  report: { id: string; version: number; observations: { id: string }[] };
  reviewerId: string;
}

export function postResultReviewRecorded(input: ResultReviewRecordedInput): void {
  if (!isL360EventsEnabled()) return;
  const { patientId, labRequestId, report, reviewerId } = input;
  void postL360Event({
    eventType: LAB_RESULT_REVIEW_RECORDED,
    patientId,
    sourceRef: report.id,
    idempotencyKey: `${LAB_RESULT_REVIEW_RECORDED}:${report.id}:${report.version}`,
    occurredAt: new Date().toISOString(),
    payload: {
      labRequestId,
      labReportId: report.id,
      labResultIds: report.observations.map((o) => o.id),
      decision: 'verified',
      reviewerId,
    },
  });
}
